import React, { createContext, useEffect, useState } from "react";

import PropTypes from "prop-types";
import { message } from "antd";
import { emit_invoice } from "../services";

export const MassiveEmitionContext = createContext({
	toggleDrawerMassiveEmition: () => {},
	modifyInvoice: () => {},
	emitMassive: () => {},
	setOpenEmailConfiguration: () => {},
	isIncomplete: false,
	isDrawerOpen: false,
	invoice: {},
	isLoading: false,
	openEmailConfiguration: false
});
  
export const MassiveEmitionProvider = ({ children }) => {
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [isIncomplete, setIsIncomplete] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [openEmailConfiguration, setOpenEmailConfiguration] = useState(false);

	const [invoice, setInvoice] = useState({
		establishment_id: undefined,
		invoice_type: undefined,
		currency: undefined,
		item_type: undefined,
		item_description: undefined,
		taxes: [],
		receptors: [],
		frases: [],
		accounting_account: undefined,
		email_message: undefined,
	});

	const modifyInvoice = (key, value) => {
		setInvoice(prevState => ({
			...prevState,
			[key]: value,
		}));
	};

	useEffect(() => {
		if (
			invoice.establishment_id === undefined ||
			invoice.invoice_type === undefined ||
			invoice.currency === undefined ||
			invoice.item_type === undefined ||
			invoice.item_description === undefined ||
			invoice.receptors.length === 0 ||
			invoice.receptors.some(receptor => receptor.success)
		) setIsIncomplete(true);
		else setIsIncomplete(false);
	}, [
		invoice.establishment_id, 
		invoice.invoice_type, 
		invoice.currency, 
		invoice.item_type, 
		invoice.item_description, 
		invoice.receptors,
		invoice.email_message
	]);

	useEffect(() => {
		const successfulReceptors = invoice.receptors.filter(receptor => receptor.success);
		if (successfulReceptors.length > 0) {
			setTimeout(() => {
				setInvoice(prevState => ({
					...prevState,
					receptors: prevState.receptors.filter(receptor => !receptor.success)
				}));
			}, 1500);
		}
	}, [invoice.receptors]);

	const emitMassive =async (token, company) => {
		setIsLoading(true);
		if (isIncomplete && invoice.email_message === undefined) return message.error("Por favor complete la información");
		const data = {
			sender: {
				id: company.id,
				name: company.name,
				tid: company.tid,
				address: company.address
			},
			receptors: invoice.receptors.map(receptor => ({
				key: receptor.key,
				id: receptor.id,
				name: receptor.name,
				tid: receptor.tid,
				address: receptor.address,
				amount: receptor.amount,
				type_tid: "",
				country: "GT",
				contacts: receptor.selected_contacts
			})),
			specs: {
				xchange_rate: "",
				instructions: company.invoice_emition_specifications.instructions || "",
			},
			frases: invoice.frases || [],
			type: invoice.invoice_type,
			currency: invoice.currency,
			establishment_id: invoice.establishment_id,
			item: {
				description: invoice.item_description,
				type: invoice.item_type,
				taxes: invoice.taxes.map((tax) => ({shortName: tax})),
				accounting_account: invoice.accounting_account || ""
			},
			email_message: invoice.email_message || ""
		};

		try {
			const res = await emit_invoice(
				{
					token,
					emition_value: "massive",
					country: company.country,
					data
				}
			);
			if (res) {
				const updatedReceptors = invoice.receptors.map((receptor) => {
					const matchingReceptor = res.data.find(r => r.key === receptor.key);
					if (matchingReceptor) {
						return {
							...receptor,
							message: matchingReceptor.response,
							success: matchingReceptor.success
						};
					}
					return receptor;
				});
				setInvoice(prevState => ({
					...prevState,
					receptors: updatedReceptors
				}));
				setOpenEmailConfiguration(false);
				setIsLoading(false);
			}
		} catch (error) {
			message.error(error.response.data);
			setIsLoading(false);
		}
	};

	const toggleDrawerMassiveEmition = () => {
		if (isDrawerOpen) setInvoice({
			establishment_id: undefined,
			invoice_type: undefined,
			currency: undefined,
			item_type: undefined,
			item_description: undefined,
			taxes: [],
			receptors: [],
			accounting_account: undefined,
			email_message: undefined,
		});
		setIsDrawerOpen(prevState => !prevState);
	};

	return (
		<MassiveEmitionContext.Provider 
			value={{ 
				toggleDrawerMassiveEmition, 
				modifyInvoice, 
				isDrawerOpen, 
				isIncomplete,
				emitMassive,
				invoice,
				isLoading,
				openEmailConfiguration, 
				setOpenEmailConfiguration
			}}
		>
			{children}
		</MassiveEmitionContext.Provider>
	);
};

MassiveEmitionProvider.propTypes = {
	children: PropTypes.node.isRequired,
};